import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import isEmpty from 'lodash/isEmpty'
import PageLayout from './PageLayout'
import Breadcrumb from '../common/Breadcrumb'
import { SECTIONS, JSON_ENTRY_TYPES } from './../../utils/url'
import parseHealthpointService from './../../utils/healthpointParser'

import '../../assets/styles/app.scss'
import '../../assets/styles/_healthpointLayout.scss'



export default props => {
    const { service, sitemap } = props

    const normalizedHealthPoint = parseHealthpointService(service)

    return (
        <PageLayout activeSection={SECTIONS.VISITOR.key} sitemap={sitemap}>
            {service && (
                <Fragment>
                    <Helmet title={service.name} />
                    <Breadcrumb
                        page={{
                            title: service.name,
                            slug: service.name.toLowerCase().replace(/ /g, '-'),
                            __typename: JSON_ENTRY_TYPES.SERVICE,
                            groups: [{
                                title: 'Directory of Services',
                                slug: 'directory-of-services',
                            }],
                        }}
                    />
                    <main className={`wrapper full-page has-sidebar page-health-point`}>
                        <aside className="sidebar">
                            <div className="sidebar-box" style={{ maxHeight: 'initial' }}>
                                <h5>Contact Details</h5>
                                <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                                    <h6>{normalizedHealthPoint.serviceLocation.name}</h6>
                                    {normalizedHealthPoint.telecom.phone && (
                                        <p>
                                            Phone <span dangerouslySetInnerHTML={{ __html: normalizedHealthPoint.telecom.phone }} />
                                        </p>
                                    )}
                                    {normalizedHealthPoint.telecom.fax && (
                                        <p>
                                            Fax <span dangerouslySetInnerHTML={{ __html: normalizedHealthPoint.telecom.fax }} />
                                        </p>
                                    )}
                                    {normalizedHealthPoint.telecom.other && (
                                        <p>
                                            <span dangerouslySetInnerHTML={{ __html: normalizedHealthPoint.telecom.other }} />
                                        </p>
                                    )}
                                    {normalizedHealthPoint.telecom.email && (
                                        <p>
                                            Email <span dangerouslySetInnerHTML={{ __html: normalizedHealthPoint.telecom.phone }} />
                                        </p>
                                    )}
                                    {normalizedHealthPoint.contact && (
                                        <p>
                                            <span dangerouslySetInnerHTML={{ __html: normalizedHealthPoint.contact }} />
                                        </p>
                                    )}
                                    {normalizedHealthPoint.serviceLocation.address && (
                                        <p>
                                            <span dangerouslySetInnerHTML={{ __html: normalizedHealthPoint.serviceLocation.address }} />
                                        </p>
                                    )}
                                    {normalizedHealthPoint.serviceLocation.postal && (
                                        <p>
                                            <span dangerouslySetInnerHTML={{ __html: normalizedHealthPoint.serviceLocation.postal.address }} />
                                        </p>
                                    )}
                                </div>
                            </div>
                        </aside>
                        <div className="content">
                            <h1 className="section-headline">{service.name}</h1>
                            <div dangerouslySetInnerHTML={{ __html: normalizedHealthPoint.comment }} />
                            {normalizedHealthPoint.people && normalizedHealthPoint.people.length > 0 && (
                                <div>
                                    <h3>Consultants</h3>
                                    <ul>
                                        {normalizedHealthPoint.people.map(person => (
                                            <li key={person.display}>
                                                <strong>{person.display}</strong> {person.title}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            {normalizedHealthPoint.expectations && (
                                <div>
                                    <h3>Referral Expectations</h3>
                                    <div dangerouslySetInnerHTML={{ __html: normalizedHealthPoint.expectations }} />
                                </div>
                            )}
                            {!isEmpty(normalizedHealthPoint.procedures) && (
                                <div>
                                    <h3>Common Conditions / Procedures / Treatments</h3>
                                    {normalizedHealthPoint.procedures.map(procedure => (
                                        <div key={procedure.name}>
                                            <h4>{procedure.name}</h4>
                                            <div dangerouslySetInnerHTML={{ __html: procedure.description }} />
                                        </div>
                                    ))}
                                </div>
                            )}
                            This information has been provided by{' '}
                            <a href="http://www.healthpoint.co.nz/" target="_blank" rel="noopener noreferrer">
                                healthpoint.co.nz
                            </a>
                            , helping people better understand and use New Zealand health services.
                        </div>
                    </main>
                </Fragment>
            )}
        </PageLayout>
    )
}
